import React, { useEffect, useState } from "react";
import { BrowserView, isDesktop, MobileView } from "react-device-detect";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import MainLayout from "src/bepaid/layouts/MainLayout";

import Button from "src/bepaid/components/Form/controls/Button";

import ROUTES from "src/bepaid/routes";
import { history } from "src/ipm-shared/store";
import { useMakePaymentUrlParams } from "src/bepaid/pages/Payments/hooks";

import classnames from "classnames";
import styles from "./RecipientSelectType.module.scss";
import FeatureGateUtil from "src/ipm-shared/components/FeatureGating/Util";
import { SUPPLIER_PAYOUT_TYPES } from "src/ipm-shared/store/model/PaymentRequest/const";

const View = (props: any) => {
  const { supplierPayoutType, setSupplierPayoutType } = props;
  const { replaceRouteWithParams } = useMakePaymentUrlParams(
    ROUTES.PAYMENTS_CREATION
  );
  const [loading, setLoading] = useState(false);

  const paymentMethodTypes = [
    {
      name: "UEN",
      description: "",
      entity: SUPPLIER_PAYOUT_TYPES.UEN
    },
    {
      name: "Bank Account ",
      description: "",
      entity: SUPPLIER_PAYOUT_TYPES.BANK_ACCOUNT
    }
  ];

  const moveForward = () => {
    setLoading(true); // ok

    setTimeout(() => {
      history.push(
        replaceRouteWithParams(ROUTES.RECIPIENTS_SUPPLIERS_CREATE, {
          newEntity: "supplier",
          newAction: "select"
        })
      );

      return;
    }, 500);
  };

  const onClose = () => {
    setSupplierPayoutType(null);
    history.push(ROUTES.RECIPIENTS_SUPPLIERS);
  };
  useEffect(() => {
    if (
      !FeatureGateUtil.verifyFeature(props.features, "PAY_TO_UEN_FLOW") ||
      !props.isSingaporeAccount
    ) {
      onClose();
    }
  }, []);

  const renderContent = () => {
    return (
      <>
        <div
          className={classnames(styles.wrapper, {
            [styles.desktop]: isDesktop
          })}
        >
          <ul className={styles.list}>
            {paymentMethodTypes.map(
              ({ name, description, entity }, idx: number) => (
                <li
                  key={idx}
                  onClick={() => {
                    setSupplierPayoutType(entity);
                  }}
                  className={classnames({
                    [styles.selected]: entity === supplierPayoutType
                  })}
                >
                  <b>{name}</b>
                  <span>{description}</span>
                </li>
              )
            )}
          </ul>
        </div>
      </>
    );
  };

  const renderBtnSubmit = () => {
    return (
      <Button
        id={"ipaymy_btn_select_suppplier_type"}
        wrapperClassName={styles.wrapperButton}
        className={styles.button}
        onClick={moveForward}
        type="primary"
        htmlType="button"
        loading={!supplierPayoutType || loading}
      >
        {loading ? "Moving forward..." : "Move forward"}
      </Button>
    );
  };

  const renderDesktopView = () => {
    return (
      <DesktopModalLayout
        id={"ipaymy_select_supplier_type"}
        title={"Select Supplier Type"}
        onClose={onClose}
        maxWidth450={true}
        onSubmit={moveForward}
        btnSubmit={renderBtnSubmit()}
      >
        {renderContent()}
      </DesktopModalLayout>
    );
  };

  const renderMobileView = () => {
    return (
      <MainLayout
        id={"ipaymy_select_supplier_type"}
        header={{
          title: "Select Supplier Type",
          hideMenu: true,
          onClose: onClose
        }}
        footer={renderBtnSubmit()}
      >
        {renderContent()}
      </MainLayout>
    );
  };

  return (
    <>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderMobileView()}</MobileView>
    </>
  );
};

export default View;
